import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  ul, ol {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    font-size: 0.9rem;
  }

  ol {
    counter-reset: item;
  }

  ol > li {
    display: block;
    margin-bottom: 0.3rem;
    position: relative;
  }

  ol > li:before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    position: absolute;
    left: -1.5rem;
    width: 1.5rem;
    text-align: right;
  }

  ul > li {
    margin-bottom: 0.3rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 使用条款

本使用条款（以下简称"本条款"）规定了本应用（以下简称"本服务"）的使用条件。用户应当遵守本条款使用本服务。

## 第1条（适用范围）

本条款适用于与本服务使用相关的一切关系。如果本服务另有规定，该单独规定也构成本条款的一部分。如果单独规定与本条款有冲突，以单独规定为准。

## 第2条（服务内容的变更和终止）

本服务可能会在事先通知的情况下，变更、追加或终止服务内容。用户同意这一点，对于内容变更或终止相关的损失，本服务不承担责任。

## 第3条（禁止事项）

用户在使用本服务时，不得进行以下行为：

1. 违反法律或公序良俗的行为
2. 与犯罪行为相关的行为
3. 妨碍本服务运营的行为
4. 侵犯第三方或本服务的知识产权、肖像权、隐私权等其他权利的行为
5. 收集或积累其他用户个人信息的行为
6. 提供虚假信息的行为
7. 对本服务系统进行未经授权的访问、反向工程、反编译、反汇编等分析行为
8. 垃圾信息行为或损害本服务信誉的行为
9. 可能对本服务的网络或系统造成不良影响的行为
10. 使用或故意传播可能影响本服务功能的软件或代码的行为
11. 损害本服务或第三方信用或名誉的行为
12. 违反本条款或本服务运营政策的行为
13. 其他本服务认为不适当的行为

## 第4条（服务提供的暂停等）

本服务可能会因维护、系统故障等原因，在未事先通知的情况下暂时停止或中断服务。对于因停止造成的损失，本服务不承担责任。

## 第5条（免责声明）

1. 本服务不保证没有事实上或法律上的缺陷（包括安全性、可靠性、准确性等）。
2. 对于因使用本服务而产生的损失，本服务不承担责任。

## 第6条（知识产权）

本服务的内容、设计、程序等相关的著作权和商标权等知识产权，属于本服务或拥有合法权利的第三方。用户不得擅自使用这些内容。

## 第7条（个人信息的处理）

本服务将根据"隐私政策"适当处理用户的个人信息。

## 第8条（权利义务转让的禁止）

用户不得将本服务的使用权转让、转租或作为担保提供给第三方。

## 第9条（通知）

本服务的通知将通过本服务内显示或其他被认为适当的方式进行。通知内容在显示后立即生效。

## 第10条（广告的显示）

本服务可能在用户的使用环境中显示广告。

## 第11条（使用条款的变更）

1. 本服务可以在认为符合用户一般利益或认为必要时变更本条款。
2. 本条款的变更将事先通知，如果在通知后继续使用，则视为用户同意变更后的条款。

## 第12条（附则）

本条款自在本服务内公布时起生效。
  `;

  return (
    <Container>
      <Content>
        <Title>使用条款</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 